import { fetcher } from '@commenda/utils';

import {
  TIndirectTaxBulkUploadTransactionsParams,
  TIndirectTaxFileWithSignedUrl,
} from './types';

export async function bulkUploadIndirectTaxTransactions(
  body: TIndirectTaxBulkUploadTransactionsParams,
  token?: string
): Promise<{
  success: boolean;
  data?: unknown;
  error?: string;
}> {
  try {
    // Safe: FileBasic may include a signedUrl from cloud storage — strip it before sending to the API
    const { signedUrl: _, ...fileWithoutSignedUrl } = body.file as TIndirectTaxFileWithSignedUrl;
    const sanitizedBody = {
      ...body,
      file: fileWithoutSignedUrl,
    };

    const response = await fetcher(
      'new-sales-tax/transactions/bulk/csv',
      { method: 'POST', body: sanitizedBody },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to upload transactions',
      };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Failed to upload transactions';
    return { success: false, error: errorMessage };
  }
}
